import WorldMap from "./components/WorldMap";

function App() {
  return <WorldMap />;
}

export default App;